import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DepartamentoService } from 'src/app/service/departamento.service';
import { aplicarFiltrosConsulta } from 'src/app/util/consulta/wow-consulta.util';
import { Departamento } from './departamento';

@Component({
  selector: 'app-departamento-consulta',
  templateUrl: './departamento-consulta.component.html',
  styleUrls: [
    './departamento-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class DepartamentoConsultaComponent {

  departamentos: Departamento[] = [];
  tipoFiltros = ['ID', 'Nome'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;
  consultaRealizada = false;

  constructor(
    private service: DepartamentoService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  consultar() {
    this.service.listar().subscribe(lista => {
      this.departamentos = aplicarFiltrosConsulta(lista ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: d => d.id,
        nome: d => d.nome,
        ativo: d => d.ativo !== false,
      });
      this.consultaRealizada = true;
    }, () => this.snackBar.open('Erro ao listar departamentos.', 'ERRO', { duration: 2500 }));
  }

  novo() {
    this.router.navigate(['/departamento/form']);
  }

  editar(item: Departamento) {
    if (item.id) {
      this.router.navigate(['/departamento/form', item.id]);
    }
  }

  inativar(item: Departamento) {
    if (!item.id || !confirm('Inativar este departamento?')) {
      return;
    }
    this.service.inativar(item.id).subscribe(() => {
      this.snackBar.open('Departamento inativado.', 'OK', { duration: 2000 });
      this.consultar();
    });
  }
}
